import { render, staticRenderFns } from "./join_service_expo.vue?vue&type=template&id=b003d19c&scoped=true&"
import script from "./join_service_expo.vue?vue&type=script&lang=js&"
export * from "./join_service_expo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003d19c",
  null
  
)

export default component.exports